module.exports = __webpack_public_path__ + "img/logo.ac64e72a.svg";